import { useCallback } from 'react';
import { ActionType, ComponentType } from '@cbhq/client-analytics';
import { isAppSwitch } from '@cbhq/identity-shared/utils';

import { useProfileMenuV2 } from '../providers/ProfileMenuV2Provider';

import { useAnalytics } from './useAnalytics';

export function useManageAccountNavigation() {
  const { logEvent } = useAnalytics();
  const { profileManagementUrl } = useProfileMenuV2();

  return useCallback(() => {
    logEvent('manage_account_click', {
      action: ActionType.click,
      componentType: ComponentType.link,
    });

    if (!profileManagementUrl) {
      return;
    }

    if (isAppSwitch({ url: profileManagementUrl })) {
      window.open(profileManagementUrl, '_blank')?.focus();
      return;
    }

    window.location.href = profileManagementUrl;
    // Necessary when the component is inside of the iframe
    window.parent.postMessage({ redirect: profileManagementUrl }, '*');
  }, [logEvent, profileManagementUrl]);
}
